import { useEffect } from "react";

import Loader from "component/loader";
import { markPanelFallbackShown } from "utils/panelHandoff";

interface LoadingFallbackProps {
  // `overlay`: a full-screen dark surface for modals and panels that are opening, so nothing
  // half-drawn shows behind the loader. `inline`: a centred block in the page flow, for the
  // route-mounted containers that fill the main area. `panel`: the side menu's footprint (right
  // edge, 350px), so the loader sits in the panel, not over the whole page.
  variant: "overlay" | "inline" | "panel";
}

// The Suspense fallback for Application's lazy containers (PLAY-5251): the shared `Loader` on a
// positioned wrapper. Standalone like the skeletons - no Redux or i18n - so it stays in the main
// bundle while the container it stands in for is in its own chunk.
export function LoadingFallback({ variant }: LoadingFallbackProps) {
  useEffect(() => {
    if (variant === "panel") markPanelFallbackShown();
  }, [variant]);

  return (
    <div className={`lazy-loading lazy-loading-${variant}`}>
      <Loader />
    </div>
  );
}

export default LoadingFallback;
